import { TextStyle as p } from "../../node_modules/@tiptap/extension-text-style/dist/index.mjs";
import { Plugin as g, PluginKey as k } from "../../node_modules/prosemirror-state/dist/index.mjs";
const u = new k("restoreMarks"), P = p.extend({
  addProseMirrorPlugins() {
    return [m()];
  }
}), m = () => new g({
  key: u,
  appendTransaction: (l, i, r) => {
    const a = l.some((e) => e.docChanged), c = !i.selection.eq(r.selection);
    if (!a && !c)
      return null;
    const { selection: d } = r, { $head: o } = d;
    if (o.parent.content.size === 0 || o.parent.content.size === 1 && o.parent.textContent === "") {
      let e = r.storedMarks || o.marks();
      if (!e || e.length === 0) {
        let n = o.pos - 1;
        for (; n > 0; ) {
          const t = r.doc.resolve(n).marks();
          if (t.length > 0) {
            e = t;
            break;
          }
          n--;
        }
      }
      if (e && e.length > 0) {
        const n = [
          "bold",
          "italic",
          "strike",
          "underline",
          "textStyle",
          "textColor",
          "textBackgroundColor",
          "fontSize",
          "fontFamily"
        ], s = e.filter((t) => n.includes(t.type.name));
        if (s.length > 0) {
          const t = r.tr;
          return t.setStoredMarks(s), t;
        }
      }
    }
    return null;
  }
});
export {
  P as TextStyle
};
